import React, {useState, useEffect} from 'react';
import DOMPurify from 'dompurify';
import { IoClose as Close } from 'react-icons/io5';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import LinearProgress from '@mui/material/LinearProgress';
import BorderBlueButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderBlueButtonV2';
import UserInfoService from '@Helpers/URLHelpers/UserInfoService';
import InvitationService from '@Helpers/URLHelpers/InvitationService';
import ErrorHandler from '@Root/ErrorHandler';
import UserSeatService from '@Helpers/URLHelpers/BillingService/UserSeatService';
import './BuyProUserSeats.scss';

export default function BuyProUserSeats(props) {

    const [loading, setLoading] = useState(true);
    const [cursor, setCursor] = useState('auto');
    const [showSearchUser, setShowSearchUser] = useState(true);
    const [userList, setUserList] = useState([]);
    const [isInvited, ,setIsInvited] = useState([]);
    const [sentInvitations, setSentInvitations] = useState([]);
    const [seatDetails, setSeatDetails] = useState({});
    const [inviteeFullName, setInviteeFullName] = useState();
    const [inviteeId, setInviteeId] = useState();
    const userSeatService = new UserSeatService();
    const userInfoService = new UserInfoService();
    const invitationService = new InvitationService();
    const errorHandler = new ErrorHandler();
    const activeUserId = JSON.parse(localStorage.getItem('activeUserId'));
    const className = 'buyProUserSeats';

    useEffect(()=>{
        renderData();
    },[]);

    const renderData = async()=> {
        await renderUserSeatDetails();
    }

    const renderUserData = async (keyword) => {
        try {
            let usersData = await userInfoService.searchUserByKeyword(keyword);
            usersData = JSON.parse(usersData.body);
            let users = [];
            for (let i = 0; i < usersData.length; i++) {
                if (usersData[i].id !== activeUserId) {
                    users.push(usersData[i]);
                }
            }
            let sentInvitations = await invitationService.getSentInvitationListForUser(activeUserId);
            sentInvitations = JSON.parse(sentInvitations.body);
            setUserList(users);
            setSentInvitations(sentInvitations !== null ? sentInvitations : [])
        } catch (err) {
            errorHandler.handleError(err);
        }
    }

    const renderUserSeatDetails = async ()=> {
        try {
            setLoading(true);
            let getDetails = await userSeatService.getUserSeatDetailsByOrgIdAndSeatType(props.org.id, 'formAgent');
            getDetails = JSON.parse(getDetails.body);
            setSeatDetails(getDetails);
        } catch (err) {
            errorHandler.handleError(err);
        }
        setLoading(false);
    }

    const handleSearch = (e) => {
        let value = DOMPurify.sanitize(e.target.value.toLowerCase());
        if (value.trim() === '') setShowSearchUser(true);
        else {
            setShowSearchUser(false);
            renderUserData(value);
        }
    }

    const handleDisable = (userId) => {
        if (props.project === undefined) {
            for (let i = 0; i < sentInvitations.length; i++) {
                if (sentInvitations[i].inviteeId === userId &&
                    sentInvitations[i].orgId === props.org.id) return true;
            }
            return false;
        } else {
            for (let i = 0; i < sentInvitations.length; i++) {
                if (sentInvitations[i].inviteeId === userId &&
                    sentInvitations[i].orgId === props.org.id) return true;
            }
            return false;
        }
    }

    const handleInvite = async (user, index) => {
        setCursor('wait');
        setInviteeId(user.id);
        setInviteeFullName(user.fullName);
        submitInvitation(user.id);
    }

    const submitInvitation = async(inviteeId)=> {
        setCursor('wait');
        let permissions = ['read', 'write'];
        let invitation = {
            inviterId: activeUserId,
            orgId: props.org?.id,
            teamId: 0,
            inviteeId: inviteeId,
            permissions: JSON.stringify(permissions)
        }
        try {
            let response = await invitationService.createFormAgentInvitation(invitation);
            await renderUserSeatDetails();
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
    }

    const updateHistory = () => {
        let navHistory = JSON.parse(localStorage.getItem('navHistory'));
        let view = JSON.parse(localStorage.getItem('view'))
        let history = {
            'view': view,
            'env': {
                currentProject: localStorage.getItem('currentProject'),
                currentProjectTitle: localStorage.getItem('currentProjectTitle'),
                currentEpic: localStorage.getItem('currentEpic'),
                currentStory: localStorage.getItem('currentStory'),
                currentTask: localStorage.getItem('currentTask'),
                currentTestingGround: localStorage.getItem('currentTestingGround'),
                currentTeam: localStorage.getItem('currentTeam'),
                currentOrg: localStorage.getItem('currentOrg')
            }
        }
        navHistory = [...navHistory, history];
        localStorage.setItem('navHistory', JSON.stringify(navHistory));
    }

    const handleBuyClick = ()=> {
        updateHistory();
        localStorage.setItem('view', JSON.stringify({subType: 'billing', type: 'userManagement'}));
        window.dispatchEvent(new Event('storage'));
    }

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            aria-labelledby='modal-buy-pro-user-seat'>
                <div className={className}>
                    <div className={className + '__inner'}>
                        <div className={className + '__inner__titleBar flex-row-center-space-between'}>
                            <div className={className + '__inner__titleBar__title'}>
                                Add Users to {props.org.orgName}
                            </div>
                            <Close className={className + '__inner__titleBar__close close-button'}
                                onClick={props.closePopup}/>
                        </div>
                        <div className={className + '__inner__body'}>
                            {
                                loading ?
                                    <LinearProgress className={className + '__inner__body__loader default-loader'} color='inherit'/>
                                :
                                    <>
                                        <div className={className + '__inner__body__top flex-row-flex-start-space-between'}>
                                            <div className={className + '__inner__body__top__left'}>
                                                <div className={className + '__inner__body__top__left__t1'}>
                                                    Pro user Seat Details
                                                </div>
                                                <div className={className + '__inner__body__top__left__t2'}>
                                                    You have {seatDetails.available} seats Available.
                                                </div>
                                            </div>
                                            <div className={className + '__inner__body__top__right flex-column-center-1vh-gap'}>
                                                <div className={className + '__inner__body__top__right__t1'}>
                                                    {seatDetails.usedSeat}/{seatDetails.total}
                                                </div>
                                                {
                                                    seatDetails.available === 0 &&
                                                        <div className={className + '__inner__body__top__right__button'}>
                                                            <BorderBlueButtonV2
                                                                text={'Buy'}
                                                                onClick={handleBuyClick}/>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                        <div className={className + '__inner__body__search'}>
                                            <label className={className + '__searchLabel'}>Search for a User: </label>
                                            <TextField
                                                type='text'
                                                placeholder='Start typing user name...'
                                                variant='outlined'
                                                maxRows='1'
                                                size='small'
                                                style={{width: '30%'}}
                                                onChange={handleSearch}
                                            />
                                        </div>
                                    </>
                            }
                        </div>
                        <div>
                            {
                                showSearchUser ?
                                    null :
                                    <>
                                        {
                                            userList === null || userList.length === 0 ?
                                                <div className={className + '__user__notFound'}>User not
                                                    found!</div> : null
                                        }
                                        {
                                            userList.map((value, index) => {
                                                return (
                                                    <div className={className + '__user'} key={value.id}>
                                                        <div
                                                            className={className + '__user__text'}
                                                            onClick={() => {}}>
                                                            {value.userName} : {value.fullName}
                                                        </div>
                                                        <div className={className + '__user__invite flex-row-flex-start-1vw-gap'}>
                                                            <BorderBlueButtonV2
                                                                text={'Invite'}
                                                                onClick={() => handleInvite(value, index)}
                                                                disabled={isInvited.includes(index) ? true : handleDisable(value.id) || seatDetails.available === 0 || cursor == 'wait'}/>
                                                            {
                                                                seatDetails.available === 0 &&
                                                                    <BorderBlueButtonV2
                                                                        text={'Buy'}
                                                                        disabled={cursor == 'wait'}
                                                                        onClick={handleBuyClick}/>
                                                            }
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </>
                            }
                        </div>
                    </div>
                </div>
        </Modal>
    )
}